import type { ReactNode } from 'react'
import { Link, type LinkProps } from '@tanstack/react-router'
import { Picto, PictoBadge } from './pictos.tsx'

type Tone = 'green' | 'sand' | 'water' | 'flag' | 'slate'

/** A row that opens a page: a pictogram in its badge, the words, a chevron. The whole row is the target (56 px at least). */
export function RowLink({ to, search, hash, icon, tone = 'green', title, hint, aside, testId, className = '' }: {
  to: LinkProps['to']; search?: LinkProps['search']; hash?: string; icon: string; tone?: Tone; title: ReactNode; hint?: ReactNode; aside?: ReactNode; testId?: string; className?: string
}) {
  return (
    <Link to={to} search={search as never} hash={hash} className={`row-link ${className}`} data-testid={testId}>
      <PictoBadge name={icon} tone={tone} />
      <span className="flex min-w-0 flex-1 flex-col">
        <span className="text-lg font-semibold leading-snug">{title}</span>
        {hint && <span className="meta">{hint}</span>}
      </span>
      {aside}
      <Picto name="chevron" className="size-5 shrink-0 opacity-40" />
    </Link>
  )
}
